// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/style.scss
// module id = 768
// module chunks = 0